export default __webpack_public_path__ + "static/media/remove-promocode.164fc307.svg";